import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';

const About = () => {
 return (
  <Container dir='rtl'>
   <Row>
    <Col>
     <h2>אודות</h2>
     <h4 className='text-white'>בית D.A נדל"ן</h4>
     <p>
      היי נעים מאוד דוד אמסלם יועץ נדל”ן באזור חיפה אשר מחוייב לערכי המקצוענות,
      המצוינות, היושרה והשקיפות ברמה הגבוהה ביותר.
     </p>

     <p>
      משרדי באזור חיפה וסביבתה מחוייב לערכי המקצוענות, המצוינות, היושרה והשקיפות
      ברמה הגבוהה ביותר.
     </p>

     <p>
      במשרדנו מועסקים סוכני נדל”ן בכירים בעלי רישיון לתיווך במקרקעין מטעם משרד
      המשפטים,המתמחים בשיווק דירות יד 2, דירות חדשות, נכסים מסחריים ויזמויות.
     </p>

     <p>
      הייחודיות שלנו באה לידי ביטוי בצוות מקצועי של סוכני נדל”ן אשר עובדים
      בשיטות עבודה חדשניות ומתקדמות ואשר מחוייבים לסטנדרטים הגבוהים ביותר של
      שירות ללקוח.
     </p>

     <p>
      בנוסף, משרדנו מציע שירותי עו”ד המתמחים בלעדית בענף הנדל”ן, כמו גם שירות
      יעוץ משכנתאות וליווי של חברה המתמחה במתן פתרונות משכנתא.
     </p>
    </Col>
   </Row>
  </Container>
 );
};

export default About;
